var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"ma-2",attrs:{"rules":_vm.rules,"dense":"","flat":"","outlined":"","clearable":"","clear-icon":"mdi-close","hide-details":"","label":"Stream Name"},model:{value:(_vm.streamName),callback:function ($$v) {_vm.streamName=$$v},expression:"streamName"}})
}
var staticRenderFns = []

export { render, staticRenderFns }